import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../shared/api.service';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss']
})
export class MainContentComponent implements OnInit {

  private eventId: string;
  private tokenId: string;
  
  public myAntomy=[  
    {id:'candidate', title:'Candidate',desc:'Here HR Manager can update selected candidate',image_cardview:'./assets/img/candidate.jpg',alttext:'Candidate Logo',pageName:'candidate'}, 
    {id:'process', title:'Processes',desc:'Here HR Manager can create different process',image_cardview:'./assets/img/process.jpg',alttext:'Process Logo',pageName:'process'},
    {id:'panel-m', title:'Panel Member',desc:'Here HR Manager can update the Panel Members',image_cardview:'./assets/img/panel-member.jpg',alttext:'Panel Member Logo',pageName:'panel'},		
    {id:'status', title:'Status',desc:'Here HR Manager can see live status of the entire event',image_cardview:'./assets/img/status.jpg',alttext:'Status Logo',pageName:'status'},		
    ]
  constructor(
    private router: Router, 
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService) { 
      
    }

  ngOnInit() {
    this.eventId = this.activatedRoute.snapshot.paramMap.get('eventId');
    this.tokenId = this.activatedRoute.snapshot.paramMap.get('tokenId');
    if (this.eventId != null && this.tokenId != null) {
      localStorage.setItem("eventId", this.eventId);
      localStorage.setItem("tokenId", this.tokenId);
    } else if (this.apiService.getEventId() != null &&
              this.apiService.getTokenId() != null) {
      this.eventId = this.apiService.getEventId();
      this.tokenId = this.apiService.getTokenId();
      // this.router.navigate(['ims/' + this.eventId + '/' + this.tokenId]);
    }
  }
  redirectPage(pageName) {
    switch (pageName) {
      case "candidate":
        this.router.navigate(['candidates']);
        break;
      case "process":
        this.router.navigate(['processes']);
        break;
      case "panel":
        this.router.navigate(['panel-member']);
        break;
      case "status":
        this.router.navigate(['live-statuses']);
        break;
      default:
        this.router.navigate(['']);
        break;
    }

  }
}